import { Component, EventEmitter, Input, OnInit, Output, OnDestroy } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDatepicker } from '@angular/material/datepicker';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { LOCALE_ES } from '@app/@core/constants/common.constants';
import {
  FORM_AUTO,
  FORM_BP,
  FORM_CONSUMO,
  FORM_MG,
  FORM_MG_NO_SHOP,
  INTERVINIENTE_1_SOCIOECONOMIC_DATA,
  INTERVINIENTE_2_SOCIOECONOMIC_DATA,
  INTERVINIENTE_3_SOCIOECONOMIC_DATA,
  INTERVINIENTE_4_SOCIOECONOMIC_DATA,
  PRESCRIBER_CONTACT_DATA,
  REQUEST_MODE_VIEW,
  SOCIOECONOMIC_DATA,
  WORK_SITUATION_AUTONOMO,
  WORK_SITUATION_OFFICIAL,
  WORK_SITUATION_BECARIO,
  WORK_SITUATION_PARADO,
  WORK_SITUATION_NO_TRABAJA,
  WORK_SITUATION_PENSIONISTA,
  WORK_SITUATION_JUBILADO,
  REQUEST_MODE_NEW,
  MAX_INCOME_DIALOG,
  REQUEST_MODE_EDIT,
  PENDIENTES_DE_DATOS,
  INTERVINIENTE_1_HOLDER_DATA,
  INTERVINIENTE_2_HOLDER_DATA,
  INTERVINIENTE_3_HOLDER_DATA,
  INTERVINIENTE_4_HOLDER_DATA,
  WORK_SITUATION_PERMANENT,
} from '@app/@core/constants/requests.constants';
import { CustomValidatorsService } from '@app/@shared/custom-validators/custom-validators.service';
import { ResponseDialogComponent } from '@app/@shared/dialogs/response/response-dialog.component';
import { DatepickerUtilsService } from '@app/@shared/services/utils/datepicker-utils.service';
import { CombosStore } from '@app/requests/combos-service/combos.store';
import { CommonDataDTO } from '@app/requests/model/combos-model';
import { Participant, StatesFieldsFrontDTO } from '@app/requests/model/requests-model';
import { RequestsSaveSendStore } from '@app/requests/requests-save-send-service/requests-save-send.store';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { TranslateService } from '@ngx-translate/core';
import * as _moment from 'moment';
import { Moment } from 'moment';

const moment = _moment;
const LIVING_SITUATION_RENT = '3';
const LIVING_SITUATION_BUSINESS = '5';
const LIVING_SITUATION_FAMILY = '4';
const LIVING_SITUATION_MORTGAGE = '2';
const LIVING_SITUATION_OWNED = '1';

@UntilDestroy()
@Component({
  selector: 'scf-socioeconomic-data',
  templateUrl: './socioeconomic-data.component.html',
  styleUrls: ['./socioeconomic-data.component.scss'],
})
export class SocioeconomicDataComponent implements OnInit, OnDestroy {
  @Input() public isMG: boolean;
  @Input() public isBP: boolean;
  @Input() public isMgWithShopping: boolean;
  @Input() public isConsumo: boolean;
  @Input() public isAuto: boolean;
  @Input() public isUptake: boolean;
  @Input() public interviniente: Participant;
  @Input() public isRepsol: boolean;
  @Input() public isGS: boolean;
  @Input() mode: string = 'new';
  @Input() state: CommonDataDTO;
  @Input() request: any = null;
  @Input() public languageRequest: string;
  @Input() public numInterviniente: string = '1';
  @Output() public changeContinueStatus = new EventEmitter<any>();
  @Input() public yearLivingAntiquy: number;
  @Input('operative') set operative(data: any) {
    if (data) {
      const index = this.interviniente ? INTERVINIENTE_1_SOCIOECONOMIC_DATA : SOCIOECONOMIC_DATA;

      if (data === 'EIC' && this.requestStore.listaFormulariosConsumo.includes(this.socioeconomicDataForm)) {
        this.requestStore.listaFormulariosConsumo[index] = null;
      } else if (data !== 'EIC' && !this.requestStore.listaFormulariosConsumo.includes(this.socioeconomicDataForm)) {
        this.requestStore.setFormularioConsumo(this.socioeconomicDataForm, index);
      }
    }
  }
  @Output() public isFinishedLoading = new EventEmitter<any>();

  public socioeconomicDataForm: FormGroup;

  employmentSituationList: CommonDataDTO[] = [];
  professionList: CommonDataDTO[] = [];
  sectorBusinessList: CommonDataDTO[] = [];
  cnaeList: CommonDataDTO[] = [];
  residentialSituationList: CommonDataDTO[] = [];
  originsRevenueList: CommonDataDTO[] = [];
  numPersonInChargeList: string[] = [];
  isAutonomo: boolean = false;
  listCnaeEmpty = [
    WORK_SITUATION_PARADO,
    WORK_SITUATION_NO_TRABAJA,
    WORK_SITUATION_PENSIONISTA,
    WORK_SITUATION_JUBILADO,
  ];

  currentDate: Date = new Date();
  maxDate = new Date();
  minDate: Date = new Date('1/1/1900');

  isLivingExpensesOptional: boolean = false;
  dniHolder: string;
  dniListIntervinients: any[];

  //PE_725 Fenix
  fieldsDisabled: StatesFieldsFrontDTO[];

  //Loading combos
  private isEmploymentSituationLoading: boolean = true;
  private isResidentialSituationLoading: boolean = true;
  private isCnaeLoading: boolean = true;
  private isOriginisRevenueLoading: boolean = true;
  private isNumPersonInChargeLoading: boolean = true;
  private isJobLoading: boolean = true;
  private isEnterpriseActivityLoading: boolean = true;

  constructor(
    private formBuilder: FormBuilder,
    private requestStore: RequestsSaveSendStore,
    private combosStore: CombosStore,
    private customValidators: CustomValidatorsService,
    private translateService: TranslateService,
    public dialog: MatDialog,
    private datepickerUtils: DatepickerUtilsService
  ) {}

  ngOnInit() {
    this.socioeconomicDataForm = this.formBuilder.group({
      laboralSituation: ['', Validators.required],
      job: [{ value: '', disabled: true }, Validators.required],
      enterpriseActivity: [{ value: '', disabled: true }, Validators.required],
      enterpriseAntiquity: ['', Validators.required], //[Validators.required, isAntiquityValid]],
      enterpriseName: [''],
      nifOrCif: ['', this.isAuto ? Validators.required : null],
      enterpriseProvince: [''],
      enterpriseTelephone: ['', this.customValidators.isPhoneValid],
      originsRevenue: [''],
      incomeMonthly: ['', [Validators.required, Validators.maxLength(11)]],
      incomeOther: ['', Validators.maxLength(11)],
      cnae: [{ value: '', disabled: true }, [Validators.required]],
      livingSituation: ['', Validators.required],
      livingExpenses: [''],
      livingAntiquity: [''],
      peopleInCharge: [''],
    });

    this.translateService.currentLang === LOCALE_ES ? this.datepickerUtils.spanish() : this.datepickerUtils.catalan();
    this.translateService.onLangChange
      .pipe(untilDestroyed(this))
      .subscribe((event) =>
        event.lang === LOCALE_ES ? this.datepickerUtils.spanish() : this.datepickerUtils.catalan()
      );

    //Get Combos
    this.getLaboralSituation();
    this.getResidentialSituation();
    this.getOriginsRevenue();
    this.getNumPersonInCharge();

    if (this.request?.workSituation == WORK_SITUATION_AUTONOMO) {
      this.socioeconomicDataForm.controls.enterpriseName.setValidators([]);
    } else {
      this.socioeconomicDataForm.controls.enterpriseName.setValidators([Validators.required]);
    }

    if (this.isConsumo || this.isAuto) {
      this.socioeconomicDataForm.addControl('incomeAnnual', new FormControl('', [Validators.maxLength(11)]));
    }

    if (this.requestStore.getMarcaFormulario() === FORM_BP) {
      this.requestStore.setFormularioBonpreu(this.socioeconomicDataForm, SOCIOECONOMIC_DATA);
    } else if (this.requestStore.getMarcaFormulario() === FORM_MG_NO_SHOP) {
      this.requestStore.setFormularioMangoNoShopping(this.socioeconomicDataForm, SOCIOECONOMIC_DATA);
    } else if (this.requestStore.getMarcaFormulario() === FORM_MG) {
      this.requestStore.setFormularioMg(this.socioeconomicDataForm, SOCIOECONOMIC_DATA);
    } else if (
      this.requestStore.getMarcaFormulario() === FORM_CONSUMO ||
      this.requestStore.getMarcaFormulario() === FORM_AUTO
    ) {
      let isConsumo = this.requestStore.getMarcaFormulario() === FORM_CONSUMO;
      if (this.interviniente) {
        switch (this.interviniente.id) {
          case 1:
            isConsumo
              ? this.requestStore.setFormularioConsumo(this.socioeconomicDataForm, INTERVINIENTE_1_SOCIOECONOMIC_DATA)
              : this.requestStore.setFormularioAutos(this.socioeconomicDataForm, INTERVINIENTE_1_SOCIOECONOMIC_DATA);
            break;
          case 2:
            this.requestStore.setFormularioAutos(this.socioeconomicDataForm, INTERVINIENTE_2_SOCIOECONOMIC_DATA);
            break;
          case 3:
            this.requestStore.setFormularioAutos(this.socioeconomicDataForm, INTERVINIENTE_3_SOCIOECONOMIC_DATA);
            break;
          case 4:
            this.requestStore.setFormularioAutos(this.socioeconomicDataForm, INTERVINIENTE_4_SOCIOECONOMIC_DATA);
            break;
          default:
            console.error('Interviniente Not found!');
        }
      } else {
        isConsumo
          ? this.requestStore.setFormularioConsumo(this.socioeconomicDataForm, SOCIOECONOMIC_DATA)
          : this.requestStore.setFormularioAutos(this.socioeconomicDataForm, SOCIOECONOMIC_DATA);
      }
    }

    this.requestStore.changeDniHolder$.subscribe((value) => {
      this.dniHolder = value;
      if (this.socioeconomicDataForm.controls.laboralSituation.value == WORK_SITUATION_AUTONOMO) {
        // cif should be the holder dni for autonomo
        if (!this.interviniente) {
          this.socioeconomicDataForm.controls.nifOrCif.setErrors(
            this.customValidators.isNIFAutonomo(this.socioeconomicDataForm.controls.nifOrCif.value, this.dniHolder)
          );
        }
      } else {
        //no autonomo, cif should be diferent
        if (!this.interviniente) {
          this.socioeconomicDataForm.controls.nifOrCif.setErrors(
            this.customValidators.isNIFNoAutonomo(this.socioeconomicDataForm.controls.nifOrCif.value, this.dniHolder)
          );
        }
      }
    });

    this.requestStore.changeDniListIntervinients$.subscribe((value) => {
      this.dniListIntervinients = value;
      if (this.socioeconomicDataForm.controls.laboralSituation.value == WORK_SITUATION_AUTONOMO) {
        // cif should be the holder dni for autonomo
        if (this.interviniente) {
          let dniIntervinient = this.dniListIntervinients.find((dni) => dni.index == this.interviniente.id).value;
          this.socioeconomicDataForm.controls.nifOrCif.setErrors(
            this.customValidators.isNIFAutonomo(this.socioeconomicDataForm.controls.nifOrCif.value, dniIntervinient)
          );
        }
      } else {
        //no autonomo, cif should be diferent
        if (this.interviniente) {
          let dniIntervinient = this.dniListIntervinients.find((dni) => dni.index == this.interviniente.id)?.value;
          this.socioeconomicDataForm.controls.nifOrCif.setErrors(
            this.customValidators.isNIFNoAutonomo(this.socioeconomicDataForm.controls.nifOrCif.value, dniIntervinient)
          );
        }
      }
    });

    this.socioeconomicDataForm.statusChanges.subscribe(() => {
      this.emitStatusForm();
    });

    if (this.mode !== REQUEST_MODE_NEW) {
      this.setValuesToForm();
      this.isEnterpriseAntiquityRequired(this.socioeconomicDataForm.controls.laboralSituation.value);
      if (this.isConsumo || this.isAuto) {
        this.isOptionalLivingExpenses();
      }
      if (this.mode === REQUEST_MODE_VIEW && this.state.id !== PENDIENTES_DE_DATOS) {
        this.socioeconomicDataForm.disable();
      }
    } else {
      this.isEnterpriseActivityLoading = false;
      this.isJobLoading = false;
      this.changeLoadingState();
    }

    if (this.isRepsol || this.isGS) {
      for (const key in this.socioeconomicDataForm.controls) {
        this.socioeconomicDataForm.get(key).clearValidators();
        this.socioeconomicDataForm.get(key).updateValueAndValidity();
      }
    }

    this.emitStatusForm();
    this.changeLoadingState();
  }

  ngOnDestroy(): void {
    if (this.interviniente) {
      if (this.isConsumo) {
        this.requestStore.listaFormulariosConsumo.splice(INTERVINIENTE_1_SOCIOECONOMIC_DATA, 1);
      } else if (this.isAuto) {
        if (this.requestStore.listaFormulariosAutos.length >= PRESCRIBER_CONTACT_DATA) {
          if (this.requestStore.listaFormulariosAutos[INTERVINIENTE_1_HOLDER_DATA] === undefined)
            this.requestStore.listaFormulariosAutos.splice(INTERVINIENTE_1_SOCIOECONOMIC_DATA, 1);
          if (this.requestStore.listaFormulariosAutos[INTERVINIENTE_2_HOLDER_DATA] === undefined)
            this.requestStore.listaFormulariosAutos.splice(INTERVINIENTE_2_SOCIOECONOMIC_DATA, 1);
          if (this.requestStore.listaFormulariosAutos[INTERVINIENTE_3_HOLDER_DATA] === undefined)
            this.requestStore.listaFormulariosAutos.splice(INTERVINIENTE_3_SOCIOECONOMIC_DATA, 1);
          if (this.requestStore.listaFormulariosAutos[INTERVINIENTE_4_HOLDER_DATA] === undefined)
            this.requestStore.listaFormulariosAutos.splice(INTERVINIENTE_4_SOCIOECONOMIC_DATA, 1);
        } else {
          this.requestStore.listaFormulariosAutos.splice(INTERVINIENTE_1_SOCIOECONOMIC_DATA, 1);
        }
      }

      const isInvalid = this.requestStore.listaFormulariosAutos.findIndex((form) => form?.status === 'INVALID');
      this.requestStore.setEnviarPeticion(isInvalid < 0);
    }
  }

  ngAfterViewInit() {
    if (this.mode !== REQUEST_MODE_VIEW) {
      if (this.request?.workSituation == WORK_SITUATION_AUTONOMO) {
        this.socioeconomicDataForm.controls.nifOrCif.setValidators([]);
        this.socioeconomicDataForm.controls.nifOrCif.updateValueAndValidity();
      }
      if (this.isConsumo || this.isAuto) {
        //CIF validation
        if (this.isConsumo) {
          if (this.request?.workSituation == WORK_SITUATION_AUTONOMO) {
            this.isAutonomo = true;

            this.socioeconomicDataForm.controls.cnae.enable({ onlySelf: true });
            this.socioeconomicDataForm.controls.cnae.setValidators([Validators.required]);

            this.socioeconomicDataForm.controls.incomeAnnual.setValidators([Validators.required]);

            //cif no mandatory for autonomo
            this.socioeconomicDataForm.controls.nifOrCif.setValidators([this.customValidators.isNifOrCifValid]);

            if (!this.interviniente) {
              this.socioeconomicDataForm.controls.nifOrCif.setErrors(
                this.customValidators.isNIFAutonomo(this.request?.companyCif, this.request?.documentId)
              );
            } else {
              //para los intervinientes
              this.socioeconomicDataForm.controls.nifOrCif.setErrors(
                this.customValidators.isNIFAutonomo(
                  this.request?.companyCif,
                  this.request?.intervinient[this.interviniente.id].documentId
                )
              );
            }
          } else if (this.request?.workSituation == WORK_SITUATION_OFFICIAL) {
            this.socioeconomicDataForm.controls.nifOrCif.setValidators([this.customValidators.isValidCIF]);
          } else {
            this.socioeconomicDataForm.controls.nifOrCif.setValidators([this.customValidators.isNifOrCifValid]);
          }
        } else {
          //autos
          if (this.request?.workSituation == WORK_SITUATION_AUTONOMO) {
            this.isAutonomo = true;
            this.socioeconomicDataForm.controls.cnae.enable({ onlySelf: true });
            this.socioeconomicDataForm.controls.cnae.setValidators([Validators.required]);

            this.socioeconomicDataForm.controls.incomeAnnual.setValidators([Validators.required]);

            if (!this.interviniente) {
              this.socioeconomicDataForm.controls.nifOrCif.setErrors(
                this.customValidators.isNIFAutonomo(this.request?.companyCif, this.request?.documentId)
              );
            } else {
              //para los intervinientes
              this.socioeconomicDataForm.controls.nifOrCif.setErrors(
                this.customValidators.isNIFAutonomo(
                  this.request?.companyCif,
                  this.request?.intervinient[this.interviniente.id].documentId
                )
              );
            }
          } else if (this.request?.workSituation == WORK_SITUATION_OFFICIAL) {
            this.socioeconomicDataForm.controls.nifOrCif.setValidators([
              Validators.required,
              this.customValidators.isValidCIF,
            ]);
          } else {
            this.socioeconomicDataForm.controls.nifOrCif.setValidators([
              Validators.required,
              this.customValidators.isNifOrCifValid,
            ]);
          }
        }

        //no autonomo: cif should be different of dni
        if (this.request?.workSituation != WORK_SITUATION_AUTONOMO) {
          if (!this.interviniente) {
            this.socioeconomicDataForm.controls.nifOrCif.setErrors(
              this.customValidators.isNIFNoAutonomo(this.request?.companyCif, this.request?.documentId)
            );
          } else {
            //para los intervinientes
            if (this.request) {
              this.socioeconomicDataForm.controls.nifOrCif.setErrors(
                this.customValidators.isNIFNoAutonomo(this.request?.companyCif, this.request?.documentId)
              );
            }
          }
        }

        this.socioeconomicDataForm.controls.enterpriseProvince.setValidators([
          Validators.required,
          Validators.maxLength(25),
        ]);
        this.socioeconomicDataForm.controls.originsRevenue.setValidators([Validators.required]);
        if (!this.isGS && !this.isRepsol) {
          this.socioeconomicDataForm.controls.originsRevenue.updateValueAndValidity();
        }
      } else if (this.isMgWithShopping || this.isMG || this.isBP) {
        this.socioeconomicDataForm.controls.livingAntiquity.setValidators(Validators.required);
        this.socioeconomicDataForm.controls.peopleInCharge.setValidators(Validators.required);
      }
    }
  }

  ngAfterContentChecked() {
    //PE_725 Fenix
    if (this.mode === REQUEST_MODE_EDIT && this.request !== null && this.request.fieldsDisable !== null) {
      this.fieldsDisabled = this.request.fieldsDisable;
      this.disableFieldsByCore();
    }
  }

  private emitStatusForm() {
    if (this.interviniente) {
      switch (this.interviniente.id) {
        case 1:
          this.changeContinueStatus.emit({
            form: <FormGroup>this.socioeconomicDataForm,
            id: INTERVINIENTE_1_SOCIOECONOMIC_DATA,
          });
          break;
        case 2:
          this.changeContinueStatus.emit({
            form: <FormGroup>this.socioeconomicDataForm,
            id: INTERVINIENTE_2_SOCIOECONOMIC_DATA,
          });
          break;
        case 3:
          this.changeContinueStatus.emit({
            form: <FormGroup>this.socioeconomicDataForm,
            id: INTERVINIENTE_3_SOCIOECONOMIC_DATA,
          });
          break;
        case 4:
          this.changeContinueStatus.emit({
            form: <FormGroup>this.socioeconomicDataForm,
            id: INTERVINIENTE_4_SOCIOECONOMIC_DATA,
          });
          break;
        default:
          console.error('Interviniente Not found!');
      }
    } else {
      this.changeContinueStatus.emit({ form: <FormGroup>this.socioeconomicDataForm, id: SOCIOECONOMIC_DATA });
    }
  }

  chosenOnlyYearHandler(normalizedYear: Moment, datepicker: MatDatepicker<Moment>) {
    const ctrlValue = this.socioeconomicDataForm.controls.livingAntiquity.value;
    if (ctrlValue) {
      ctrlValue.year(normalizedYear.year());
      this.socioeconomicDataForm.controls.livingAntiquity.setValue(ctrlValue);
    } else {
      this.socioeconomicDataForm.controls.livingAntiquity.setValue(
        moment('1/1/' + normalizedYear.year().toString(), 'DD-MM-YYYY')
      );
    }
    datepicker.close();
  }

  chosenYearHandler(normalizedYear: Moment) {
    const ctrlValue = this.socioeconomicDataForm.controls.enterpriseAntiquity.value;
    if (ctrlValue) {
      ctrlValue.year(normalizedYear.year());
      this.socioeconomicDataForm.controls.enterpriseAntiquity.setValue(ctrlValue);
    } else {
      this.socioeconomicDataForm.controls.enterpriseAntiquity.setValue(
        moment('1/1/' + normalizedYear.year().toString(), 'DD-MM-YYYY')
      );
    }
  }

  chosenMonthHandler(normalizedMonth: Moment, datepicker: MatDatepicker<Moment>) {
    const ctrlValue = this.socioeconomicDataForm.controls.enterpriseAntiquity.value;
    if (ctrlValue) {
      ctrlValue.month(normalizedMonth.month());
      console.log(ctrlValue);
      this.socioeconomicDataForm.controls.enterpriseAntiquity.setValue(ctrlValue);
    } else {
      this.socioeconomicDataForm.controls.enterpriseAntiquity.setValue(
        moment('1/' + (normalizedMonth.month() + 1).toString() + '/' + normalizedMonth.year().toString(), 'DD-MM-YYYY')
      );
    }
    datepicker.close();
  }

  public onChangeOriginsRevenue(event: Event) {
    this.showModalNotRevenues();
  }

  showModalNotRevenues() {
    if (this.socioeconomicDataForm.controls.originsRevenue.value === 'S') {
      this.socioeconomicDataForm.controls.incomeMonthly.setValue('1,00 €');
      if (
        this.socioeconomicDataForm.controls.laboralSituation.value !== '' &&
        this.socioeconomicDataForm.controls.laboralSituation.value !== WORK_SITUATION_BECARIO &&
        this.socioeconomicDataForm.controls.laboralSituation.value !== WORK_SITUATION_PARADO &&
        this.socioeconomicDataForm.controls.laboralSituation.value !== WORK_SITUATION_NO_TRABAJA
      ) {
        //show dialog sin ingresos
        const dialogConfig = new MatDialogConfig();
        dialogConfig.width = '90%';
        dialogConfig.maxWidth = '550px';

        dialogConfig.data = {
          text: this.translateService.instant('dialog.noincome.text'),
          icon: undefined,
          buttonCancel: false,
        };
        this.dialog.open(ResponseDialogComponent, dialogConfig);
        this.socioeconomicDataForm.controls.originsRevenue.setValue(null);
      }
    }
  }

  public onChangeLaboralSituation(value: any) {
    if (value) {
      this.isAutonomo = false;
      if (this.isConsumo) {
        //consumo, cif optional
        if (value === WORK_SITUATION_AUTONOMO) {
          this.socioeconomicDataForm.controls.enterpriseName.setValidators([]);
          this.isAutonomo = true;
          this.socioeconomicDataForm.controls.cnae.setValue(null);
          this.socioeconomicDataForm.controls.cnae.setValidators([Validators.required]);

          this.socioeconomicDataForm.controls.incomeAnnual.setValidators([Validators.required]);

          this.socioeconomicDataForm.controls.enterpriseName.setValidators([]);
          this.socioeconomicDataForm.controls.nifOrCif.setValidators([this.customValidators.isNifOrCifValid]);
        } else if (value === WORK_SITUATION_OFFICIAL) {
          this.socioeconomicDataForm.controls.nifOrCif.setValidators([this.customValidators.isValidCIF]);
          this.socioeconomicDataForm.controls.enterpriseName.setValidators([Validators.required]);
          this.socioeconomicDataForm.controls.cnae.setValue(null);

          this.socioeconomicDataForm.controls.enterpriseName.setValidators([Validators.required]);
        } else {
          this.socioeconomicDataForm.controls.cnae.setValue(null);

          this.socioeconomicDataForm.controls.enterpriseName.setValidators([Validators.required]);
          this.socioeconomicDataForm.controls.incomeAnnual.setValidators([]);
          this.socioeconomicDataForm.controls.incomeAnnual.setErrors(null);
          this.socioeconomicDataForm.controls.enterpriseName.setValidators([Validators.required]);
          this.socioeconomicDataForm.controls.nifOrCif.setValidators([this.customValidators.isNifOrCifValid]);
          this.socioeconomicDataForm.controls.nifOrCif.updateValueAndValidity();
        }
      } else if (this.isAuto) {
        //autos, cif mandatory
        if (value === WORK_SITUATION_AUTONOMO) {
          this.socioeconomicDataForm.controls.enterpriseName.setValidators([]);
          this.isAutonomo = true;
          this.socioeconomicDataForm.controls.cnae.setValue(null);
          this.socioeconomicDataForm.controls.cnae.setValidators([Validators.required]);

          this.socioeconomicDataForm.controls.incomeAnnual.setValidators([Validators.required]);

          //no mandatory for autonomo
          this.socioeconomicDataForm.controls.enterpriseName.setValidators([]);
          this.socioeconomicDataForm.controls.nifOrCif.setValidators([this.customValidators.isNifOrCifValid]);
        } else if (value === WORK_SITUATION_OFFICIAL) {
          this.socioeconomicDataForm.controls.nifOrCif.setValidators([
            Validators.required,
            this.customValidators.isValidCIF,
          ]);
          this.socioeconomicDataForm.controls.enterpriseName.setValidators([Validators.required]);
          this.socioeconomicDataForm.controls.cnae.setValue(null);

          this.socioeconomicDataForm.controls.enterpriseName.setValidators([Validators.required]);
        } else {
          this.socioeconomicDataForm.controls.cnae.setValue(null);
          this.socioeconomicDataForm.controls.incomeAnnual.setValidators([]);
          this.socioeconomicDataForm.controls.incomeAnnual.setErrors(null);
          this.socioeconomicDataForm.controls.enterpriseName.setValidators([Validators.required]);
          this.socioeconomicDataForm.controls.nifOrCif.setValidators([
            Validators.required,
            this.customValidators.isNifOrCifValid,
          ]);

          this.socioeconomicDataForm.controls.enterpriseName.setValidators([Validators.required]);
        }
      } else {
        //other products, no cif
        if (value === WORK_SITUATION_AUTONOMO) {
          this.isAutonomo = true;
          this.socioeconomicDataForm.controls.enterpriseName.setValidators([]);
          this.socioeconomicDataForm.controls.cnae.setValidators([Validators.required]);
          this.socioeconomicDataForm.controls.enterpriseName.setValidators([]);
        } else {
          this.socioeconomicDataForm.controls.cnae.setValue(null);

          this.socioeconomicDataForm.controls.enterpriseName.setValidators([Validators.required]);
        }
      }

      this.socioeconomicDataForm.controls.job.reset();
      this.socioeconomicDataForm.controls.enterpriseActivity.reset();
      this.socioeconomicDataForm.controls.enterpriseActivity.disable();

      this.socioeconomicDataForm.controls.cnae.reset();
      this.socioeconomicDataForm.controls.cnae.disable();

      this.getEmploymentSituation(value);

      this.isEnterpriseAntiquityRequired(value);
      this.showModalNotRevenues();

      this.validateCif();
    }
  }

  private getEmploymentSituation(laboralSituation: string) {
    if (laboralSituation) {
      if (!this.isLoading()) {
        this.isJobLoading = true;
        this.changeLoadingState();
      }
      this.combosStore
        .loadEmploymentSituation(laboralSituation)
        .then(
          (data) => {
            this.professionList = data;
            if (this.mode !== REQUEST_MODE_VIEW) {
              this.socioeconomicDataForm.controls.job.enable();
            }
          },
          (error) => console.error(error)
        )
        .finally(() => {
          this.isJobLoading = false;
          this.changeLoadingState();
        });
    } else this.isJobLoading = false;
  }

  onChangeJob(value: string) {
    if (value) {
      this.socioeconomicDataForm.controls.enterpriseActivity.reset();
      this.getSectorBusiness(value);
    }
  }

  private getSectorBusiness(job: string) {
    if (job) {
      if (!this.isLoading()) {
        this.isEnterpriseActivityLoading = true;
        this.changeLoadingState();
      }
      this.combosStore
        .loadSectorBusiness(job)
        .then(
          (data) => {
            this.sectorBusinessList = data;
            if (this.mode !== REQUEST_MODE_VIEW) {
              this.socioeconomicDataForm.controls.enterpriseActivity.enable();
            }
          },
          (error) => console.error(error)
        )
        .finally(() => {
          this.isEnterpriseActivityLoading = false;
          this.changeLoadingState();
        });
    } else this.isEnterpriseActivityLoading = false;
  }

  isEnterpriseAntiquityRequired(laboralSituation: string) {
    if (
      laboralSituation === WORK_SITUATION_PARADO ||
      laboralSituation === WORK_SITUATION_NO_TRABAJA ||
      laboralSituation === WORK_SITUATION_JUBILADO ||
      laboralSituation === WORK_SITUATION_PENSIONISTA
    ) {
      this.socioeconomicDataForm.controls.enterpriseAntiquity?.disable();
      this.socioeconomicDataForm.controls.enterpriseName?.disable();
      this.socioeconomicDataForm.controls.enterpriseProvince?.disable();
      this.socioeconomicDataForm.controls.enterpriseTelephone?.disable();
      this.socioeconomicDataForm.controls.nifOrCif?.disable();
      this.socioeconomicDataForm.controls.enterpriseAntiquity?.reset();
      this.socioeconomicDataForm.controls.enterpriseName?.reset();
      this.socioeconomicDataForm.controls.enterpriseProvince?.reset();
      this.socioeconomicDataForm.controls.enterpriseTelephone?.reset();
      this.socioeconomicDataForm.controls.nifOrCif?.reset();
    } else {
      this.socioeconomicDataForm.controls.enterpriseAntiquity?.enable();
      this.socioeconomicDataForm.controls.enterpriseName?.enable();
      this.socioeconomicDataForm.controls.enterpriseProvince?.enable();
      this.socioeconomicDataForm.controls.enterpriseTelephone?.enable();
      this.socioeconomicDataForm.controls.nifOrCif?.enable();
    }
  }

  numberOnly(event: any, element: any): boolean {
    const inputForm = typeof element === 'string' ? element : element?.getAttribute('formControlName');
    let value = this.socioeconomicDataForm.controls[inputForm].value;

    return this.customValidators.numberOnly(event.which ? event.which : event.keyCode, value);
  }

  transformAmount(value: any, element: any) {
    const inputForm = typeof element === 'string' ? element : element?.getAttribute('formControlName');
    let inputValue = typeof value === 'string' ? value : value?.target.value;

    this.socioeconomicDataForm.controls[inputForm].setValue(this.customValidators.transformAmount(inputValue));
  }

  setValuesToForm() {
    if (this.request) {
      this.socioeconomicDataForm.controls.laboralSituation.setValue(this.request.workSituation);
      this.getEmploymentSituation(this.request.workSituation);

      this.socioeconomicDataForm.controls.job.setValue(this.request.occupation);
      this.getSectorBusiness(this.request.occupation);

      this.socioeconomicDataForm.controls.enterpriseActivity.setValue(this.request.companySector);
      if (this.request?.workSituation == WORK_SITUATION_AUTONOMO) {
        this.isAutonomo = true;
        this.getCnaeByEnterpriseActivity(this.request.companySector);
      }

      let dateIncorp = new Date(
        this.request.incorpYear,
        this.request.incorpMonth < 12 ? this.request.incorpMonth - 1 : this.request.incorpMonth
      );

      this.socioeconomicDataForm.controls.enterpriseAntiquity.setValue(dateIncorp > this.minDate ? dateIncorp : '');

      this.socioeconomicDataForm.controls.enterpriseName.setValue(this.request.companyName);
      this.socioeconomicDataForm.controls.nifOrCif.setValue(this.request.companyCif);
      this.socioeconomicDataForm.controls.enterpriseProvince.setValue(this.request.companyPopulation);
      this.socioeconomicDataForm.controls.enterpriseTelephone.setValue(this.request.telCompany);
      this.socioeconomicDataForm.controls.originsRevenue.setValue(this.request.originRevenues);
      if (this.request.incomeNetos === '0,0') {
        this.request.incomeNetos = '';
      }
      this.socioeconomicDataForm.controls.incomeMonthly.setValue(
        this.request.incomeNetos ? this.request.incomeNetos + ' €' : this.request.incomeNetos
      );
      if (this.request.ingrMonthVble === '0,0') {
        this.request.ingrMonthVble = '';
      }
      this.socioeconomicDataForm.controls.incomeOther.setValue(
        this.request.ingrMonthVble ? this.request.ingrMonthVble + ' €' : this.request.ingrMonthVble
      );
      this.socioeconomicDataForm.controls.cnae.setValue(this.request.cnae);
      this.socioeconomicDataForm.controls.livingSituation.setValue(this.request.sitVivienda);

      if (this.mode === REQUEST_MODE_EDIT && this.request.housingExpenses === '0,0') {
        this.request.housingExpenses = '';
      }
      this.socioeconomicDataForm.controls.livingExpenses.setValue(
        this.request.housingExpenses ? this.request.housingExpenses + ' €' : this.request.housingExpenses
      );

      if ((this.isConsumo && !this.isGS && !this.isRepsol) || this.isAuto) {
        if (this.request.annualIngr === '0,0') {
          this.request.annualIngr = '';
        }
        this.socioeconomicDataForm.controls.incomeAnnual.setValue(
          this.request.annualIngr ? this.request.annualIngr + ' €' : this.request.annualIngr
        );
      } else if (this.isMgWithShopping || this.isMG || this.isBP) {
        this.socioeconomicDataForm.controls.livingAntiquity.setValue(
          this.request.antiquityProperty === '0000' ? '' : this.request.antiquityProperty
        );
        this.socioeconomicDataForm.controls.peopleInCharge.setValue(
          this.request.peopleInCharge === '0' ? '' : this.request.peopleInCharge
        );
      }
    }
  }

  changeLoadingState() {
    if (!this.isGS && !this.isRepsol) {
      this.isLoading()
        ? this.isFinishedLoading.emit({ formID: SOCIOECONOMIC_DATA, value: false })
        : this.isFinishedLoading.emit({ formID: SOCIOECONOMIC_DATA, value: true });
    } else {
      this.isFinishedLoading.emit({ formID: SOCIOECONOMIC_DATA, value: true });
    }
  }

  validateCif() {
    const inputValue = this.socioeconomicDataForm.controls.nifOrCif.value.trim().toUpperCase();
    this.socioeconomicDataForm.controls.nifOrCif.setValue(inputValue);

    if (inputValue.length === 0) return;

    const laboralSituation = this.socioeconomicDataForm.controls.laboralSituation.value;
    const isAutonomo = laboralSituation === WORK_SITUATION_AUTONOMO;

    const dniToValidate = this.interviniente
      ? this.dniListIntervinients.find((dni) => dni.index === this.interviniente.id)?.value.toUpperCase()
      : this.dniHolder.toUpperCase();

    if (isAutonomo) {
      this.socioeconomicDataForm.controls.nifOrCif.setErrors(
        this.customValidators.isNIFAutonomo(inputValue, dniToValidate) ||
          this.customValidators.isNifOrCifValid(this.socioeconomicDataForm.controls.nifOrCif)
      );
    } else {
      this.socioeconomicDataForm.controls.nifOrCif.setErrors(
        this.customValidators.isNIFNoAutonomo(inputValue, dniToValidate) ||
          this.customValidators.isNifOrCifValid(this.socioeconomicDataForm.controls.nifOrCif)
      );
    }
  }

  private getLaboralSituation() {
    this.combosStore.employmentSituationList$.subscribe((valor: CommonDataDTO[]) => {
      this.employmentSituationList = valor;
      if (this.employmentSituationList.length === 1) {
        this.socioeconomicDataForm.controls.laboralSituation.setValue(this.employmentSituationList[0].id);
      }
      this.isEmploymentSituationLoading = false;
      this.changeLoadingState();
    });
  }

  private getResidentialSituation() {
    this.combosStore.residentialSituationList$.subscribe((valor: CommonDataDTO[]) => {
      this.residentialSituationList = valor;
      if (this.residentialSituationList.length === 1) {
        this.socioeconomicDataForm.controls.livingSituation.setValue(this.residentialSituationList[0].id);
      }
      this.isResidentialSituationLoading = false;
      this.changeLoadingState();
    });
  }

  getCnaeByEnterpriseActivity(enterpriseActivity: string) {
    this.socioeconomicDataForm.controls.cnae.reset();
    if (this.isAutonomo) {
      this.combosStore.loadCnae(enterpriseActivity).then(
        (data) => {
          this.cnaeList = data;

          if (
            this.mode != REQUEST_MODE_VIEW &&
            this.socioeconomicDataForm.controls.laboralSituation.value == WORK_SITUATION_AUTONOMO
          ) {
            this.socioeconomicDataForm.controls.cnae.enable();
          }

          if (this.cnaeList.length === 1) {
            this.socioeconomicDataForm.controls.cnae.setValue(this.cnaeList[0].id);
          }
        },
        (error) => console.error(error)
      );
    }
  }

  private getOriginsRevenue() {
    this.combosStore.originsRevenueList$.subscribe((valor: CommonDataDTO[]) => {
      this.originsRevenueList = valor;
      if (this.originsRevenueList.length === 1) {
        this.socioeconomicDataForm.controls.originsRevenue.setValue(this.originsRevenueList[0].id);
      }
      this.isOriginisRevenueLoading = false;
      this.changeLoadingState();
    });
  }

  private getNumPersonInCharge() {
    this.numPersonInChargeList = this.combosStore.numPersonInChargeList;
    if (this.numPersonInChargeList.length === 1) {
      this.socioeconomicDataForm.controls.peopleInCharge.setValue(this.numPersonInChargeList[0]);
    }
    this.isNumPersonInChargeLoading = false;
    this.changeLoadingState();
  }

  private isLoading(): boolean {
    return (
      this.isEmploymentSituationLoading ||
      this.isResidentialSituationLoading ||
      this.isOriginisRevenueLoading ||
      this.isNumPersonInChargeLoading ||
      this.isJobLoading ||
      this.isEnterpriseActivityLoading
    );
  }

  onIncomeMonthlyBlur(value: any, element: any) {
    this.transformAmount(value, element);
    this.showDialogIncome();
  }

  private showDialogIncome() {
    const income = this.socioeconomicDataForm.controls.incomeMonthly.value;
    if (income) {
      const value = income?.slice(0, -1).trim().replace('.', '').replace(',', '.');
      if (value >= MAX_INCOME_DIALOG) {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.width = '90%';
        dialogConfig.maxWidth = '550px';

        dialogConfig.data = {
          text: this.translateService.instant('dialog.socioeconomic.income'),
          icon: undefined,
          title: this.translateService.instant('dialog.info.title'),
          buttonCancel: false,
        };

        this.dialog.open(ResponseDialogComponent, dialogConfig);
      }
    }
  }

  onChangeLivingSituation(value: string) {
    this.isOptionalLivingExpenses(value);
  }

  private isOptionalLivingExpenses(currentLivingSituation?: string) {
    if (this.isAuto || this.isConsumo) {
      const livingSituation = currentLivingSituation
        ? currentLivingSituation
        : this.socioeconomicDataForm.controls?.livingSituation.value;
      const livingExpenses = this.socioeconomicDataForm.controls?.livingExpenses;

      if (livingSituation === LIVING_SITUATION_BUSINESS || livingSituation === LIVING_SITUATION_FAMILY) {
        this.isLivingExpensesOptional = true;
        livingExpenses.clearValidators();
        livingExpenses.enable();
        livingExpenses.updateValueAndValidity();
      } else if (livingSituation === LIVING_SITUATION_RENT || livingSituation === LIVING_SITUATION_MORTGAGE) {
        this.isLivingExpensesOptional = false;
        livingExpenses.enable();
        livingExpenses.addValidators([Validators.required, Validators.maxLength(11)]);
        livingExpenses.updateValueAndValidity();
      } else {
        if (livingSituation === LIVING_SITUATION_OWNED) {
          this.isLivingExpensesOptional = false;
          livingExpenses.setValue(null);
          livingExpenses.disable();
        } else {
          livingExpenses.enable();

          if (!livingExpenses.hasValidator(Validators.required)) {
            this.isLivingExpensesOptional = false;
            livingExpenses.addValidators([Validators.required, Validators.maxLength(11)]);
            livingExpenses.updateValueAndValidity();
          }
        }
      }
    }
  }

  lettersOnly(event: any): boolean {
    if (event.type === 'paste') {
      const pastedText = event.clipboardData.getData('text');
      let containStrangeCharacter = false;
      for (let i = 0; i < pastedText.length && !containStrangeCharacter; i++) {
        let charCode = pastedText.charCodeAt(i);
        if (!this.customValidators.lettersOnly(charCode)) {
          containStrangeCharacter = true;
        }
      }
      if (containStrangeCharacter) {
        return false;
      } else {
        return true;
      }
    } else {
      return this.customValidators.lettersOnly(event.which ? event.which : event.keyCode);
    }
  }

  private disableFieldsByCore() {
    if (this.fieldsDisabled !== null && this.fieldsDisabled !== undefined) {
      const form = this.socioeconomicDataForm;
      this.fieldsDisabled.forEach((field) => {
        const toDisable = form.get(field.campoName);
        if (toDisable !== null && toDisable !== undefined) {
          toDisable.disable();
        }
      });
    }
  }
}
